import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/cn';

interface Props {
    label?: string;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const SIZE_MAP: Record<NonNullable<Props['size']>, string> = {
    sm: 'size-4',
    md: 'size-6',
    lg: 'size-10',
};

export function LoadingSpinner({ label, size = 'md', className }: Props) {
    return (
        <div
            role="status"
            aria-live="polite"
            className={cn('flex flex-col items-center gap-2', className)}
        >
            <Loader2 className={cn(SIZE_MAP[size], 'animate-spin')} aria-hidden />
            {label && <span className="text-sm text-muted-foreground">{label}</span>}
        </div>
    );
}
